import { makeAutoObservable } from "mobx";
import { axios } from "../../utils/axios";

export default class UIStore {
    public editing: boolean = false;
    public flashMessage: string = "";

    public show500: boolean = false;

    public showScores: boolean = false;
    public simpleEditorShownFieldList: string[] = [];

    public darkModeOn: boolean = false;

    public adaptable: boolean = true;

    public fieldError = {
        confirm_password: "",
        email: "",
        password: "",
        username: ""
    };

    public questionTypes: string[] = [];
    public selectedQuestionTypes: string[] = ["short-answer"];

    private rootStore: any = undefined;

    constructor(rootStore: any) {
        this.rootStore = rootStore;
        let darkModeOn;
        darkModeOn = localStorage.getItem("darkModeOn");
        if (darkModeOn === "true") {
            this.darkModeOn = true;
            this.enableDarkMode();
        }

        this.setAdaptable = this.setAdaptable.bind(this);

        makeAutoObservable(this);
    }

    public init() {
        let darkModeOnString = window.localStorage.getItem("modquiz.settings.ui.darkMode");
        if (darkModeOnString === "true") {
            this.darkModeOn = true;
            this.enableDarkMode();
        }

        let adaptableString = window.localStorage.getItem("modquiz.settings.quizzer.adaptable");
        if (adaptableString === "false") {
            console.log("Setting this.adaptable to false");
            this.adaptable = false;
        }

        let selectedQuestionTypes = window.localStorage.getItem("modquiz.settings.ui.selectedQuestionTypes")
        if (selectedQuestionTypes) {
            this.selectedQuestionTypes = selectedQuestionTypes.split(",");
        }
    }

    public showGeneric500() {
        this.show500 = true;
    }

    public setSelectedQuestionTypes(newArray: string[]) {
        if (newArray.length < 1) {
            this.selectedQuestionTypes = ["short-answer"];
        }
        this.selectedQuestionTypes = newArray;
        window.localStorage.setItem("modquiz.settings.ui.selectedQuestionTypes", this.selectedQuestionTypes.join(","));

    }

    /*
     * In the quizzer, we need to know which question types are available.  This loads those question types so they are
     * available in the UI drop down.
     */
    public async loadQuestionTypes() {
        const store = this;
        axios()
            .get("question_types")
            .then((res: any) => {
                store.questionTypes = res.data;
            });
    }

    public setFlash(flashMessage: string) {
        this.flashMessage = flashMessage;
    }

    public toggleEditMode() {
        this.editing = !this.editing;
    }

    public toggleDarkMode() {
        this.darkModeOn = !this.darkModeOn;
        if (this.darkModeOn) {
            this.enableDarkMode();
        } else {
            this.disableDarkMode();
        }
    }

    /**************
     * Simple Editor Store
     *
     * This is code to manage client-side data around which table columns are shown in the simple subject editor.
     **************/
    public toggleSimpleEditorShownField = (fieldName: string) => {
        if (this.simpleEditorShownFieldList.includes(fieldName)) {
            this.simpleEditorShownFieldList = this.simpleEditorShownFieldList.filter(
                (filteredFieldName: string) => {
                    return fieldName !== filteredFieldName;
                }
            );
            return;
        }
        this.simpleEditorShownFieldList.push(fieldName);
    };

    public showSimpleEditorField = (fieldName: string) => {
        const normalizedName = fieldName.trim();
        if (!normalizedName || this.simpleEditorShownFieldList.includes(normalizedName)) return;
        this.simpleEditorShownFieldList.push(normalizedName);
    };

    public setSimpleEditorShownFields(fieldNames: string[]) {
        this.simpleEditorShownFieldList = [...fieldNames];
    }

    public setAdaptable() {
        this.adaptable = !this.adaptable;
        window.localStorage.setItem("modquiz.settings.quizzer.adaptable", this.adaptable.toString());
        console.log(this.adaptable.toString());
    }

    private enableDarkMode() {
        const element = document.getElementById("body-root");
        if (element) {
            element.classList.add("dark-mode");
        }
        window.localStorage.setItem("modquiz.settings.ui.darkMode", "true");
    }

    private disableDarkMode() {
        const element = document.getElementById("body-root");
        if (element) {
            element.classList.remove("dark-mode");
        }
        window.localStorage.setItem("modquiz.settings.ui.darkMode", "false");
    }
}
